import { StudentHealth } from "@services/dtos/school.dto";
import { useThemeStore } from "@stores/theme.store";
import { useDetailState } from "@utils/detail_state";
import { linkPage } from "@utils/router";
import moment from "moment";
import { useEffect } from "react";

export const StudentHealthDetailPage = () => {
  const state = useDetailState<StudentHealth>(linkPage.SCHOOL_STUDENT_HEALTH);
  const { setFooter, setHeader, setAppBar } = useThemeStore((state) => state);

  useEffect(() => {
    setFooter(false);
    setHeader({
      type: "small",
      title: "Detail Kesehatan Santri",
      buttonBack: true,
      avatar: true,
    });
    setAppBar({ title: "Detail Kesehatan Santri", leading: "back" });
  }, [setFooter, setHeader, setAppBar]);

  if (!state) return null;

  return (
    <div className="card card-style">
      <div className="content d-flex flex-column mb-0">
        <div className="color-highlight">Tanggal Keluhan</div>
        <div className="color-theme mb-3">{moment(state.tanggal ?? Date.now()).format('dddd, DD MMMM YYYY | HH:mm')}</div>
        <div className="color-highlight">Keluhan</div>
        <div className="color-theme mb-3">{state.keluhan ?? '-'}</div>
        <div className="color-highlight">Pengobatan</div>
        <div className="color-theme mb-3">{state.obat ?? '-'}</div>
        <div className="color-highlight">Catatan</div>
        <div className="color-theme mb-3">{state.catatan ?? '-'}</div>
      </div>
    </div>
  );
};
